import React, { useState } from 'react'
import { EbayListings, ReverbListings, GoogleShoppingListings } from '../channels'
import ShopifyPublications from './ShopifyPublications'

function ChannelListings() {
  const [activeTab, setActiveTab] = useState('ebay')

  const tabs = [
    { id: 'ebay', label: 'eBay Listings' },
    { id: 'reverb', label: 'Reverb Listings' },
    { id: 'google', label: 'Google Shopping' },
    { id: 'shopify-publications', label: 'Shopify Publications' }
  ]

  return (
    <div>
      <div style={{
        display: 'flex',
        gap: 'var(--space-2)',
        marginBottom: 'var(--space-4)',
        background: 'var(--color-bg-secondary)',
        padding: 'var(--space-1)',
        borderRadius: 'var(--radius)',
        width: 'fit-content'
      }}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: 'var(--space-2) var(--space-4)',
              borderRadius: 'var(--radius-sm)',
              border: 'none',
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              background: activeTab === tab.id ? 'white' : 'transparent',
              color: activeTab === tab.id ? 'var(--green-onions)' : 'var(--color-text-muted)',
              boxShadow: activeTab === tab.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'ebay' && <EbayListings />}
      {activeTab === 'reverb' && <ReverbListings />}
      {activeTab === 'google' && <GoogleShoppingListings />}
      {activeTab === 'shopify-publications' && <ShopifyPublications />}
    </div>
  )
}

export default ChannelListings
